const buttons = [
    {
      id: 1,
      text: "More Wisdom",
    },
    {
      id: 2,
      text: "Change the Quote",
    },
    {
      id: 3,
      text: "Change the Image",
    },
    {
      id: 4,
      text: "Capture",
    },
  ];

  export default buttons;